import { api } from "@/services/api"

import { SubscriptionStatusInfo } from "../types"

export const stripeService = {
  /**
   * Creates a transparent checkout session for in-app payment processing
   */
  createDirectSubscription: async (data: {
    plan_id: string
    interval: "monthly" | "yearly"
    customer_info: {
      email: string
      name: string
    }
    trial_days?: number
    payment_method_id?: string
    success_url?: string
    cancel_url?: string
  }) => {
    const response = await api.post("/billing/direct-subscription", data)
    return response.data
  },

  /**
   * Creates a checkout session for in-app payment processing
   */
  createCheckoutSession: async (data: {
    plan_id: string
    interval: "monthly" | "yearly"
    customer_info: {
      email: string
      name: string
    }
    trial_days?: number
    payment_method_id?: string
    success_url?: string
    cancel_url?: string
  }) => {
    const response = await api.post("/billing/checkout-session", data)
    return response.data
  },

  submitCheckoutSuccess: async (data: { session_id: string }) => {
    const response = await api.post("/billing/subscription/success", data)
    return response.data
  },

  /**
   * Confirms subscription with a payment method ID
   */
  confirmSubscription: async (paymentMethodId: string) => {
    const response = await api.post("/billing/confirm-subscription", {
      paymentMethodId,
    })
    return response.data
  },

  createSubscription: async (data: {
    paymentMethodId: string
    planId: string
    interval: "monthly" | "yearly"
    customerEmail: string
    customerName: string
  }) => {
    try {
      console.log(`Creating subscription with payment method:`, data.paymentMethodId)

      const response = await api.post("/billing/create-subscription", data)

      console.log(`Subscription creation response:`, response.data)
      return response.data
    } catch (error) {
      console.error("Error creating subscription:", error)
      throw error
    }
  },

  /**
   * Gets the current subscription status
   */
  getSubscriptionStatus: async (): Promise<SubscriptionStatusInfo> => {
    const response = await api.get("/billing/subscriptions/status")
    return response.data
  },
}
